import { SERVICES, waLink } from "../../data/content";
import { Reveal } from "./Reveal";

export const Services = () => (
  <section id="servicios" data-testid="services-section" className="relative py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <span className="text-xs uppercase tracking-[0.3em] text-[#C5A059]">Lo que puedo hacer por ti</span>
        <h2 className="mt-4 font-serif text-4xl sm:text-5xl md:text-6xl text-[#F3EFE7] tracking-tight max-w-3xl">
          Servicios de tarot y trabajo espiritual
        </h2>
        <p className="mt-5 max-w-2xl text-white/70 leading-relaxed">
          Cada caso es distinto. Escríbeme, cuéntame qué te pasa y te digo con honestidad
          cómo puedo ayudarte. Sin promesas vacías.
        </p>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-12 gap-5">
        {SERVICES.map((s, i) => {
          const Icon = s.icon;
          return (
            <Reveal key={s.id} delay={(i % 3) * 0.08} className={s.span}>
              <a href={waLink(`Hola, me interesa el servicio de ${s.name}.`)} target="_blank" rel="noopener noreferrer"
                data-testid={`service-card-${s.id}`}
                className="group relative h-full flex flex-col justify-between overflow-hidden rounded-2xl border border-[#C5A059]/20 bg-[#1A0B2E]/40 p-7 hover:border-[#C5A059]/60 hover:-translate-y-1.5 transition-[transform,border-color] duration-500">
                <div className="absolute -right-16 -top-16 h-40 w-40 rounded-full bg-[#2D1350] blur-3xl opacity-0 group-hover:opacity-70 transition-opacity duration-500" />
                <div className="relative">
                  <Icon className="text-[#C5A059]" size={26} strokeWidth={1.4} />
                  <h3 className="mt-5 font-serif text-2xl md:text-3xl text-[#F3EFE7]">{s.name}</h3>
                  <p className="mt-3 text-sm md:text-base text-white/65 leading-relaxed">{s.desc}</p>
                </div>
                <span className="relative mt-6 text-xs uppercase tracking-[0.2em] text-[#C5A059] opacity-70 group-hover:opacity-100 transition-opacity duration-300">
                  Consultar →
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
